/**
 * Relative-week phrasing for a calendar-week-aligned delay.
 *
 *   1 → "next week"
 *   2 → "the week after next"
 *   n → "in N weeks"
 *
 * Shared by the delay display surfaces (CampaignDayDelayPure, TemplateBlockHeaderPure)
 * and the read-only contact campaign view (CampaignDetailPagePure).
 */
export function weekDelayLabel(weeks: number): string {
  if (weeks <= 1) return 'next week';
  if (weeks === 2) return 'the week after next';
  return `in ${weeks} weeks`;
}
